export default "__VITE_ASSET___mBvKQ$5__"